"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roncofreddo": {
    "a6c76bc2": [{
      "hkey": "e78e5180",
      "slug": "cento",
      "name": "Cento",
      "primary": true,
      "skipSearch": false
    }],
    "cento-musano-felloniche": [{
      "hkey": "e78e5180",
      "slug": "cento",
      "name": "Cento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "097cd912": [{
      "hkey": "73adc717",
      "slug": "santa-paola",
      "name": "Santa Paola",
      "primary": true,
      "skipSearch": false
    }],
    "santa-paola-castiglione": [{
      "hkey": "73adc717",
      "slug": "santa-paola",
      "name": "Santa Paola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "940f9985": [{
      "hkey": "ff8bfc16",
      "slug": "ardiano",
      "name": "Ardiano",
      "primary": true,
      "skipSearch": false
    }],
    "sorrivoli-ardiano-diolaguardia-montecodruzzo": [{
      "hkey": "ff8bfc16",
      "slug": "ardiano",
      "name": "Ardiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;